 export function capitalizeFirstLetters(text: string, splitterChar: string){
    if(!text){
        return "-";
    }
    const arr = text.split(splitterChar);
    for (var i = 0; i < arr.length; i++) {
      arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
    }
    const str2 = arr.join(" ");
    return str2;
  }